// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__a0ON1"};